// @ts-strict-ignore
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Directive, ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding, HostListener,
  Inject,
  Input, NgZone, OnDestroy, OnInit,
  Output, ViewChild, ViewContainerRef
} from '@angular/core';
import {
  SohoBusyIndicatorDirective,
  SohoMessageService, SohoModalDialogRef,
  SohoModalDialogService,
  SohoToastService
} from 'ids-enterprise-ng';
import {
  ApplicationMenuAsOfDateDialogStatus, ApplicationMenuAsOfDateResult,
  LMActionFormDialogResult, LMActionFormDialogResultCode,
  LMActionFormDialogService,
  LMApplicationMenuAsOfDateDialogService, LMApplicationMenuProxyMenuComponent, LMApplicationMenuSearchComponent,
  LMApplicationMenuSearchService,
  LMApplicationMenuService,
  LMApplicationMenuSettingsDialogComponent, LMApplicationMenuSubMenuService,
  LMApplicationMenuUserContextDialogService, LMApplicationMenuUserContextDialogStatus,
  LMApplicationMenuUserContextResult, LMCtrlShiftClickEvent,
  LMFormRequestService, LMHtmlUrlDocComponent,
  LMLoginService, LMReportPersonalizationDialogResult, LMReportPersonalizationDialogResultCode,
  LMReportPersonalizationDialogService, LoginDialogStatus, LoginResult
} from '@app/components';
import {
  LMBusyIndicatorService, LMComponentInfoService,
  LMContextService,
  LMErrorUtilService,
  LMFormatUtilService,
  LMLoggerService,
  LMRoamingUIProfileService, LMRouteComponentService,
  LMSpecService,
  LMUrlUtilService, RoamingUIProfileResponse, RoamingUIProfileResult
} from '@app/services';
import {
  AppConstants, LMBrowserUtilService,
  LMContextUtilService,
  LMDialogButtonKey,
  LMGlobalUtilService,
  LMUniqueIdService
} from '@app/utils';
import { LMGlobalPersonalization, LMGlobalPersonalizationService } from '@app/states';
import { Router } from '@angular/router';
import { EMPTY, forkJoin, interval, Observable, of, Subject } from 'rxjs';
import { SubscriptionLike as ISubscription } from 'rxjs/internal/types';
import { catchError, debounceTime, first, switchMap, takeUntil } from 'rxjs/operators';
import * as urltemplate from 'url-template';
import { isEmpty } from 'lodash-es';
import { LMThemeService } from '@banner/lm-theme.service';
import { LMCreateReportDialogService, LMReportsCatalogService } from '@report/index';
import { LMWebAppService } from '@services/lm-webapp.service';

@Directive()
export abstract class LMApplicationMenuBaseDirective implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked {
  private _selectedRole: string;
  private notificationRefreshInterval: number;
  private unreadNotificationCount: number;
  private _displayRedDot = false;
  private m_asOfDate: string;
  private m_showDeletedRecords: boolean;
  private stopInterval$ = new Subject<boolean>();
  private pause$ = new Subject<boolean>();
  public searchFieldText$ = new Subject<string>();
  private destroyer$ = new Subject<void>();
  private dialog: SohoModalDialogRef<any>;
  private throttleId: string = null; // this is used to avoid double clicks!!!

  public actionMenuIsOpen = false;
  public mingleMode: boolean;
  public insideInforGo: boolean;

  // Initial WebAppSpec
  public webAppSpecs: Array<LMWebAppSpec>;

  // Filtered WebAppSpecs. (excludes some original specs)
  public filteredWebAppSpecs: Array<LMWebAppSpec>;

  // Spec the WebAppSpec's menu items
  public menuItemSpecs: Array<LMMenuItemSpec>;

  public aboutLink: string;
  public appHelpLink: string;
  public notificationsUrl: string;
  public inBasketUrl: string;
  public jobsUrl: string;
  public printFilesUrl: string;
  public actionsUrl: string;
  public reportsUrl: string;
  public personalizationsUrl: string;
  public savedSearchesUrl: string;
  public actorName: string;
  public actorInitials: string;
  public actorInitialsColorClass: string;
  public anonymousUser: boolean;
  public proxyMode: boolean;
  public notificationEnabled: boolean;
  public inbasketEnabled: boolean;
  public personalizationEnabled: boolean;
  public enableSavedSearch: boolean;
  public proxyEnabled: boolean;
  public webAppTitle: string;
  public webAppName: string;
  public webAppIconUrl: string;
  public selectedWebAppName: string;
  public webAppSuiteLink: string;
  public appSwitcher: LMApplicationMenuAppMenuMode;
  public webAppMenuNavigationUrl: string;
  public signOutLink: string;
  public signInLink: string;
  public registerLink: string;
  public changePasswordLink: string;
  public proxyManagementLink: string;
  public createReportUrl: string;
  public actorGroupSelectUrl: string;
  public roleSelectUrl: string;
  public roleGroupSelectUrl: string;
  public reportFieldSearchUrl: string;
  public enableUserContextMenu: boolean;
  public hasRegisterLink: boolean;
  public hasChangePasswordLink: boolean;
  public allowSetAsOfDate: boolean;
  public allowClearAsOfDate: boolean;
  public searchMode: boolean;
  public updateRequired: boolean;
  public roleSwitcher: boolean;
  public noCasualApps: number;
  public clientLogin: boolean;
  public actorUrl: string;
  public proxyUserUrls: any;
  public proxyWebApps: Array<string> = [];  // todo: type me!
  public proxyResetUrls: any;
  public menuSearchField: LMToolbarSearchField;
  public model = { searchFieldValue: '' };
  public menuSearchResultsByWebApp: LMApplicationMenuSearchResults;
  public systemSearchResults: Array<LMApplicationMenuSearchResult>;
  public reportSearchResult: Array<LMApplicationMenuSearchResult>;
  public dataSearchResult: Array<LMApplicationMenuSearchResult>;
  public showOverFlowMenuButton: boolean;
  public allowAnonymousAccess: boolean;

  // Button menu
  public applicationMenuButtons: LMApplicationMenuButton[] = [];
  public myOverflowMenuButtons: LMApplicationMenuButton[] = [];
  public menuItemSearch: LMApplicationMenuButton[] = [];


  // Single button
  public notificationsButton: LMApplicationMenuButton;
  public createReportButton: LMApplicationMenuButton;
  public reportsButton: LMApplicationMenuButton;
  public printFilesButton: LMApplicationMenuButton;
  public inbasketButton: LMApplicationMenuButton;
  public aboutButton: LMApplicationMenuButton;

  public showSearch: boolean;
  public isClassicTheme: boolean;
  public rolesPaneIsOpen = false;

  public _pause$ = new Subject<boolean>();
  public _destroy$ = new Subject<boolean>();
  public _menuItemClicked$ = new Subject<any>();
  public settings: LMGlobalPersonalization = {};
  public configFeaturesEnabled: boolean;

  public showProxy: boolean;
  public isGuestUser = false;

  public get displayRedDot(): boolean {
    return this._displayRedDot;
  }

  public set displayRedDot(display: boolean) {
    this._displayRedDot = display;
  }

  public get isPasswordReset(): boolean {
    return this.lmContextService.getContext().completePasswordReset;
  }

  public set selectedRole(selectedRole: string) {
    this._selectedRole = selectedRole;
  }

  public get selectedRole(): string {
    return this._selectedRole;
  }

  public subscriptionArray: Array<ISubscription> = []; // todo: type me!

  @Input() moduleNavDisplayMode: SohoModuleNavDisplayMode;
  @Input() visibility: string;

  @Input() set asOfDate(date: string) {
    this.allowClearAsOfDate = date !== undefined && date !== '';

    this.m_asOfDate = date;

    // only load menu when initial load has been done
    if (this.webAppSpecs) {
      this.loadMenu(this.lmUrlUtilService.getBannerSpecUrl());
    }
  }

  get asOfDate() {
    return this.m_asOfDate;
  }

  @Input() set showDeletedRecords(show: boolean) {
    this.m_showDeletedRecords = show;

    // only load menu when initial load has been done
    if (this.webAppSpecs) {
      this.loadMenu(this.lmUrlUtilService.getBannerSpecUrl());
    }
  }

  get showDeletedRecords() {
    return this.m_showDeletedRecords;
  }

  @Input() applyColorToMenu: boolean;

  @HostBinding('style.visibility') get hostVisibility() {
    return this.visibility;
  }

  @HostBinding('style.overflow') get hostOverflow() {
    return this.rolesPaneIsOpen ? 'hidden' : null;
  }

  @HostListener('click', [ '$event' ]) onClick(event) {
    let closeActionMenu = true;

    const eventPath = (event?.composedPath && event?.composedPath()) || event?.path;
    eventPath?.forEach((element) => {
      if (element?.classList?.contains('lm-application-action-menu') ||
        element?.classList?.contains('lm-application-menu-settings-btn')
      ) {
        closeActionMenu = false;
      }
    });

    if(closeActionMenu && this.actionMenuIsOpen) {
      this.closeActionMenu();
    }
  }

  @Output() menuLoaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() menuStateRestored: EventEmitter<any> = new EventEmitter<any>();
  @Output() webAppMenuLoaded: EventEmitter<any> = new EventEmitter<WebAppMenuLoadedEvent>();
  @Output() menuSearched: EventEmitter<any> = new EventEmitter<any>();
  @Output() asOfDateChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() asOfDateCleared: EventEmitter<string> = new EventEmitter<string>();
  @Output() roleSelected = new EventEmitter<any>();
  @Output() themeChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() asOfDateClearedEvent: EventEmitter<void> = new EventEmitter();

  @ViewChild('LMApplicationMenuSearchComponent') public applicationMenuSearchComponent: LMApplicationMenuSearchComponent | undefined;
  @ViewChild('UserSettingsDialog', { read: ViewContainerRef, static: true }) placeholder: ViewContainerRef;
  @ViewChild('AccessDeniedDialog', { read: ViewContainerRef, static: true }) accessDeniedplaceholder: ViewContainerRef;
  @ViewChild('LoginDialog', { read: ViewContainerRef, static: true }) loginPlaceholder: ViewContainerRef;
  @ViewChild('ChangePasswordDialog', { read: ViewContainerRef, static: true }) changePasswordPlaceholder: ViewContainerRef;
  @ViewChild('DrillbackActionFormDialog', { read: ViewContainerRef, static: true }) drillbackPlaceholder: ViewContainerRef;
  @ViewChild('ReportPersonalizationDialog', { read: ViewContainerRef, static: true }) reportPlaceholder: ViewContainerRef;
  @ViewChild('SetAsOfDateDialog', { read: ViewContainerRef, static: true }) setAsOfDatePlaceholder: ViewContainerRef;
  @ViewChild('UserContextDialog', { read: ViewContainerRef, static: true }) userContextPlaceholder: ViewContainerRef;
  @ViewChild('webAppMenuHeader') private _webAppMenu: ElementRef;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator: SohoBusyIndicatorDirective;
  @ViewChild('ActionMenu') actionMenu: ElementRef;
  @ViewChild('AppMenuSwitcher') appMenuSwitcher: ElementRef;
  @ViewChild('ExpandablePane') expandablePane: ElementRef;
  @ViewChild('AppMenuContent') appMenuContent: ElementRef;
  @ViewChild('SettingsGuide') settingsGuide: ElementRef;
  @ViewChild('AppSwitcherGuide') appSwitcherGuide: ElementRef;
  @ViewChild('menuFormDialog', { read: ViewContainerRef, static: true }) menuFormDialogPlaceholder: ViewContainerRef;

  protected constructor(
    protected sohoModalDialogService: SohoModalDialogService,
    protected sohoToastService: SohoToastService,
    protected lmAsOfDateService: LMApplicationMenuAsOfDateDialogService,
    protected lmContextService: LMContextService,
    protected lmApplicationMenuService: LMApplicationMenuService,
    protected lmFormRequestService: LMFormRequestService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmSpecService: LMSpecService,
    protected lmWebAppService: LMWebAppService,
    protected lmErrorUtilService: LMErrorUtilService,
    protected lmLoggerService: LMLoggerService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmGlobalUtilService: LMGlobalUtilService,
    protected lmLoginService: LMLoginService,
    protected lmContextUtilService: LMContextUtilService,
    protected lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    protected lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected sohoMessageService: SohoMessageService,
    protected lmApplicationMenuSearchService: LMApplicationMenuSearchService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmUserContextService: LMApplicationMenuUserContextDialogService,
    @Inject(forwardRef(() => LMActionFormDialogService)) protected lmActionFormDialogService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected router: Router,
    protected lmRoamingUIProfileService: LMRoamingUIProfileService,
    protected lmThemeService: LMThemeService,
    protected lmCreateReportDialogService: LMCreateReportDialogService,
    protected lmBrowserUtilService: LMBrowserUtilService,
    protected lmCommonReportsService: LMReportsCatalogService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected ngZone: NgZone,
    protected lmApplicationMenuSubMenuService: LMApplicationMenuSubMenuService,
    protected routeComponent: LMRouteComponentService
  ) {
    this.searchFieldText$.pipe(
      takeUntil(this.destroyer$),
      debounceTime(1000))
      .subscribe(value => {
        const length = value ? value.length : 0;
        if (length > 2) {
          this.applicationMenuSearch();
        }
      });
  }

  ngOnInit() {
    this.lmLoggerService.trace('@ApplicationMenuBaseDirective -> ngOnInit');
    this.insideInforGo = this.lmContextService.insideInforGo();
    this.searchMode = false;
    this.updateRequired = false;
    this.roleSwitcher = false;
    this.allowAnonymousAccess = this.lmContextService.allowAnonymousAccess();
    this.webAppSwitcherButtonId = this.lmContextService.testVersion() === AppConstants.TESTVERSION_V1 ? 'trigger-btn' : 'webapp-menu';
    this.getApplicationMenuPersonalization();
    this.configFeaturesEnabled = this.lmContextService.isConfigFeatureEnabled(AppConstants.FEATURE_ConfigurableFeatures);
    this.isGuestUser = this.lmContextService.isGuestUser();
    this.lmThemeService.getThemeChangeSubject().subscribe((theme) => {
      if (theme.includes('theme-classic') && !this.isClassicTheme) {
        this.isClassicTheme = true;
        this.changeDetectorRef.markForCheck();
      } else {
        this.isClassicTheme = false;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  ngAfterViewInit() {
    this.mingleMode = this.lmContextService.inMingle();
    this.loadMenu(this.lmUrlUtilService.getBannerSpecUrl());
    this.subscribeToMenuItemClick();
  }

  ngOnDestroy() {
    this.subscriptionArray.forEach(subscription => subscription.unsubscribe());
    this.stopInterval$.next(true);
    this.stopInterval$.complete();
    this.pause$.complete();
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  public ngAfterViewChecked(): void {
    if (this.updateRequired) {
      this.onWebAppMenuLoaded();
      this.updateRequired = false;
    }
  }

  /**
   * Set href url when a right click is executed
   * @param event
   * @param menuItem
   */
  public onRoleRightClick(event: MouseEvent, menuItem: LMWebAppSpec) {
    if (menuItem && menuItem.webAppUrl) {
      (event.currentTarget as HTMLElement).setAttribute('href', menuItem.webAppUrl);
    }
  }

  public selectRole($event?: any) {
    this.roleSwitcher = true;
    this.changeDetectorRef.detectChanges();
    this.roleSelected.emit();

    this.showBusyIndicator();

    const button: any = $event.currentTarget;
    const url = button.getAttribute('navigation-menu-url');

    this.webAppTitle = button.getAttribute('title');
    this.webAppName = button.getAttribute('web-app-name');

    // For webapp without a navigation menu
    if (!url) {
      this.resetMenuItemSpecs();
      this.filteredWebAppSpecs = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName !== this.webAppName && webAppSpec.webAppTitle);
      const currentWebAppSpec = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName === this.webAppName)[0];

      this.menuItemSpecs.push({
        resourceId:   currentWebAppSpec.webAppName,
        name:         'Home',
        link:         currentWebAppSpec.webAppUrl,
        id:           'Home',
        label:        Soho.Locale.translate('Home'),
        resourceType: 'page'
      });

      this.markForRefresh();
      this.updateRequired = true;

      this.lmContextService.updateWebApp(currentWebAppSpec);
      this.lmGlobalUtilService.navigateByUrl(currentWebAppSpec.webAppUrl);

      this.hideBusyIndicator();
    } else {
      this.subscriptionArray.push(
        // Banner call to get webapp and a lot more info
        this.lmWebAppService.getWebAppMenuSpec(this.webAppName).subscribe(
          applicationMenuSpec => {
            if (applicationMenuSpec === undefined) {
              this.handleAppMenuSpecUndefinedError();
            }

            this.saveAllLevelsResponse(applicationMenuSpec);

            this.updateMenuItemSpecs(applicationMenuSpec.menuSpecs);


            this.signOutLink = applicationMenuSpec.signOutLink;

            this.resetMenuPersonalization();

            this.lmApplicationMenuService.setApplicationMenuSpec(this.menuItemSpecs);

            this.lmApplicationMenuService.updateApplicationMenuSpec(applicationMenuSpec.menuSpecs, url);

            this.markForRefresh();
            this.updateRequired = true;

            this.filteredWebAppSpecs = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName !== this.webAppName && webAppSpec.webAppTitle);
            const currentWebAppSpec = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName === this.webAppName)[0];

            this.lmContextService.updateWebApp(currentWebAppSpec);
            this.lmContextService.updateHomePageTitle(applicationMenuSpec);

            this.lmGlobalUtilService.navigateByUrl(currentWebAppSpec.webAppUrl);

            this.hideBusyIndicator();
          },
          error => {
            this._handleError(error);
          })
      );
    }
  }

  public get webAppMenuHeader(): ElementRef {
    const webAppMenuName = this.selectedWebAppName ? this.selectedWebAppName : this.webAppName;
    // @ts-ignore

    if (this._webAppMenu && this._webAppMenu.nativeElement.getAttribute('id') === webAppMenuName) {
      return this._webAppMenu;
    }
    return null;
  }

  public onMenuLoaded(event) {
    this.menuLoaded.emit(event);
  }

  public onWebAppMenuLoaded() {
    this.webAppMenuLoaded.emit({ roleSwitcher: this.roleSwitcher });
  }

  public onMenuSearched(event: LMApplicationMenuSearchEvent) {
    this.menuSearched.emit(event);
  }

  public updateMenuItemSpecs(appMenuSpecs: Array<LMMenuItemSpec>) {
    this.menuItemSpecs = appMenuSpecs;
  }

  public resetMenuItemSpecs() {
    this.menuItemSpecs = [];
  }

  public openUserSettingsDialog() {
    const dialogId = 'UserSettings';
    const buttons = [
      {
        id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CANCEL ]),
        text:  Soho.Locale.translate(LMDialogButtonKey.CANCEL),
        click: (e, modal) => {
          modal.isCancelled = true;
          modal.close(true);
        }
      },
      {
        id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.SAVE ]),
        text:  Soho.Locale.translate(LMDialogButtonKey.SAVE),
        click: (e, modal) => {
          modal.close(true);
        },
        isDefault: true
      }
    ];

    const settingsModalAttributes: SohoAttributesArray = [ {
      name: 'data-automation-id',
      value: 'lm-settings-modal'
    } ];

    this.dialog = this.sohoModalDialogService
      .modal(
        LMApplicationMenuSettingsDialogComponent,
        this.placeholder,
        { fullsize: 'responsive', attributes: settingsModalAttributes })
      .buttons(buttons)
      .title(Soho.Locale.translate(dialogId))
      .open();
  }

  public openSetAsOfDateDialog(): void {
    const date = this.lmContextService.getContext().asOfDate ? this.lmFormatUtilService.yyyymmddToDisplay(this.asOfDate) : null;
    this.lmAsOfDateService.promptAsOfDateDialog(this.setAsOfDatePlaceholder, date)
      .pipe(first())
      .subscribe((result: ApplicationMenuAsOfDateResult) => {
        if (result.status !== ApplicationMenuAsOfDateDialogStatus.RESPONSE_OK) {
          return;
        }
        this.lmLoggerService.log(result.date);
        const dbDate = this.lmFormatUtilService.yyyymmddToData(result.date);
        this.asOfDateChanged.emit(dbDate);
      });
  }

  public clearAsOfDate() {
    this.asOfDateCleared.emit();
  }

  public openSetUserContextDialog() {
    const userContextUrl = this.lmUrlUtilService.getUserContextUrl();

    this.lmSpecService.getApplicationBannerSpec(userContextUrl).subscribe(
      (response: LMApplicationBannerSpec) => {
        const userContextDialog = this.lmUserContextService.promptUserContextDialog(this.userContextPlaceholder, response.userContextFields)
          .subscribe(
            (result: LMApplicationMenuUserContextResult) => {
              if (result.status === LMApplicationMenuUserContextDialogStatus.RESPONSE_OK) {
                if (result.userContextProperties && result.saveChanges) {

                  const jsonContextPropertiesArray = [];
                  Object.keys(result.userContextProperties).forEach(key => {
                    const userContextModel: LMApplicationMenuUserContextModelField = result.userContextProperties[ key ];
                    if (userContextModel.dirty) {
                      const jsonContextProperty = {
                        id:    key,
                        value: userContextModel.value
                      };
                      jsonContextPropertiesArray.push(jsonContextProperty);
                    }
                  });

                  this.lmApplicationMenuService.updateActorContext(userContextUrl, jsonContextPropertiesArray).subscribe((ucResponse: any) => {
                    if (ucResponse.status === 'COMPLETED') {
                      window.location.href = this.lmContextService.getCurrentWebAppSpec().webAppUrl;
                    }
                  });
                }
              }
            }
          );
        this.markForRefresh();
        // this.updateRequired = true;
        this.subscriptionArray.push(userContextDialog);
      },
      error => {
        this._handleError(error);
      });
    return false;
  }

  public noActorUrl() { // tslint:disable-line (template)
    return (this.actorUrl === '#' || this.actorUrl == null);
  }

  public openHelpLink() {
    this.lmUrlUtilService.openExternalUrl(this.appHelpLink);
  }

  public openSecurityLink(link: string) {
    this.resetLastOpenedMenu();
    window.location.href = link;
  }

  public handleAppMenuSpecUndefinedError() {
    const title = Soho.Locale.translate('DocumentGenerationStatus3');
    const msg = Soho.Locale.translate('DocumentGenerationStatusMessage3');
    this.hideBusyIndicator();
    this.menuLoaded.emit(false);
    this._handleError({ title, message: msg });
    return;
  }

  private resetLastOpenedMenu() {
    const applicationMenuPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();

    if (!isEmpty(applicationMenuPersonalization) && applicationMenuPersonalization.lastOpenedMenu) {
      applicationMenuPersonalization.lastOpenedMenu = '';
    }
    this.lmGlobalPersonalizationService.saveGlobalPersonalization(applicationMenuPersonalization);
  }

  public loadMenu(url: string, syncWebApp?: boolean): void {
    this.lmLoggerService.trace('@ApplicationMenuBaseDirective -> loadApplicationMenuSpec');
    this.showBusyIndicator();

    if (syncWebApp) {
      this.filteredWebAppSpecs = [];
      this.markForRefresh();
      this.updateRequired = true;
    }

    this.subscriptionArray.push(this.lmSpecService.getApplicationBannerSpec(url).subscribe(
      (applicationMenuSpec: LMApplicationBannerSpec) => {
        if (applicationMenuSpec === undefined) {
          this.handleAppMenuSpecUndefinedError();
        }

        this.webAppSpecs = applicationMenuSpec.webApps;

        // Get reference to current web app spec
        const currentWebAppSpec = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName === this.lmContextService.getContext().webApp)[0];

        this.appSwitcher = 'casual'; //  applicationMenuSpec.appSwitcher || 'accordion';
        this.noCasualApps = applicationMenuSpec.noCasualApps;
        this.aboutLink = applicationMenuSpec.aboutLink;
        this.appHelpLink = applicationMenuSpec.appHelpLink;
        this.actionsUrl = applicationMenuSpec.myActionsUrl;
        this.inBasketUrl = applicationMenuSpec.myInBasketUrl;
        this.jobsUrl = applicationMenuSpec.myJobsUrl;
        this.notificationsUrl = applicationMenuSpec.myNotificationsUrl;
        this.printFilesUrl = applicationMenuSpec.myPrintFilesUrl;
        this.reportsUrl = applicationMenuSpec.myReportsUrl;
        this.personalizationsUrl = applicationMenuSpec.myPersonalizationsUrl;
        this.savedSearchesUrl = applicationMenuSpec.mySavedSearchesUrl;
        this.createReportUrl = this.evaluateCreateReportUrl(applicationMenuSpec);
        this.actorGroupSelectUrl = applicationMenuSpec.actorGroupSelectUrl;
        this.roleSelectUrl = applicationMenuSpec.roleSelectUrl;
        this.roleGroupSelectUrl = applicationMenuSpec.roleGroupSelectUrl;
        this.reportFieldSearchUrl = applicationMenuSpec.reportFieldSearchUrl;
        this.signOutLink = applicationMenuSpec.signOutLink;
        this.registerLink = applicationMenuSpec.registerLink;
        this.signInLink = applicationMenuSpec.signInLink;
        this.changePasswordLink = applicationMenuSpec.changePasswordLink;

        this.actorName = applicationMenuSpec.actorInfo.proxyDisplayName && !this.mingleMode ?
          `${applicationMenuSpec.actorInfo.proxyDisplayName[ 0 ]} - ${applicationMenuSpec.actorInfo.displayName[ 0 ]}`
          : applicationMenuSpec.actorInfo.displayName[ 0 ];

        this.actorInitials = this.getActorInitials();
        this.actorInitialsColorClass = this.lmThemeService.getUniqueBackgroundColorClass(this.actorInitials);
        this.actorUrl = applicationMenuSpec.actorInfo.actorUrl[ 0 ];

        // Proxy
        this.proxyUserUrls = applicationMenuSpec.proxyUserUrls;
        if (this.proxyUserUrls) {
          this.proxyWebApps = Object.keys(this.proxyUserUrls);
        }
        this.proxyResetUrls = applicationMenuSpec.proxyResetUrls;
        this.proxyMode = applicationMenuSpec.proxyMode || false;
        this.proxyEnabled = applicationMenuSpec.proxyEnabled || false;
        this.proxyManagementLink = applicationMenuSpec.proxyManagementLink;
        this.showProxy = this.evaluateProxy(applicationMenuSpec);

        this.anonymousUser = applicationMenuSpec.anonymousUser || false;
        this.clientLogin = applicationMenuSpec.clientLogin || false;
        this.webAppMenuNavigationUrl = applicationMenuSpec.webAppMenuNavigationUrl;
        if (this.lmGlobalPersonalizationService.getGlobalPersonalization().preferredWebApp !== undefined) {
          const preferredAppName = this.lmGlobalPersonalizationService.getGlobalPersonalization().preferredWebApp;
          const preferredAppSpec = this.webAppSpecs.find((preferredApp: LMWebAppSpec) => preferredApp.webAppName === preferredAppName);
          if ((this.lmContextService.getContext().webApp === preferredAppName) && preferredAppSpec !== undefined) {
            this.webAppMenuNavigationUrl = preferredAppSpec.navigationMenuUrl;
          }
        }

        this.webAppTitle = this.lmContextService.getContext().webAppTitle;
        this.webAppName = this.lmContextService.getContext().webApp;
        this.webAppIconUrl = currentWebAppSpec?.webAppIconUrl;
        this.selectedWebAppName = this.webAppName;
        this.webAppSuiteLink = applicationMenuSpec.webAppSuiteLink;

        this.hasRegisterLink = (this.registerLink === '' || this.registerLink == null) ? false : true;
        this.hasChangePasswordLink = (this.changePasswordLink === '' || this.changePasswordLink == null) ? false : true;

        this.allowSetAsOfDate = this.evaluateAsOfDate(applicationMenuSpec);
        this.allowClearAsOfDate = this.asOfDate !== undefined && this.asOfDate !== '';

        this.enableUserContextMenu = applicationMenuSpec.enableUserContextMenu;

        // TODO: Akila, is this right? Seems to always be true. And ignores the config param setting
        this.inbasketEnabled = applicationMenuSpec.inbasketEnabled || true;
        this.notificationEnabled = applicationMenuSpec.notificationEnabled || true;
        this.personalizationEnabled = this.evaluatePersonalization(applicationMenuSpec);
        this.enableSavedSearch = this.lmContextService.showUserListView();
        this.showSearch = this.evaluateShowSearch();

        if (this.isPasswordReset) {
          this.hideBusyIndicator();
          this.markForRefresh();
          this.updateRequired = true;
          this.lmLoggerService.trace('@ApplicationMenuBaseDirective -> loadApplicationMenuSpec -> complete');
          return;
        }

        this.updateButtons();

        if (this.notificationEnabled) {
          this.notificationRefreshInterval = (applicationMenuSpec.refreshIntervalMinutes) ? parseInt(applicationMenuSpec.refreshIntervalMinutes, 10) : 5;
          this.unreadNotificationCount = (applicationMenuSpec.unreadCount) ? parseInt(applicationMenuSpec.unreadCount, 10) : 0;
          this.displayRedDot = this.evaluateApplicationMenuOption('HideMenuNotifications') ? this.unreadNotificationCount > 0 : false;

          // Poll to check unread notification count
          const interval$ = interval(this.notificationRefreshInterval * 60 * 1000).pipe(
            takeUntil(this.stopInterval$)
          );
          // Pause during async call to get the notification count.
          const pausable$ = this.pause$.pipe(
            switchMap(paused => paused ? EMPTY : interval$));

          this.subscriptionArray.push(pausable$.subscribe(() => {
            this.getUnreadNotificationCount();
          }));

          this.pause$.next(false);
        }

        if (!this.webAppMenuNavigationUrl) {
          if (this.useAppSwitcher()) {
            this.resetMenuItemSpecs();
            this.filteredWebAppSpecs = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName !== this.webAppName && webAppSpec.webAppTitle);
            if (this.filteredWebAppSpecs.length === 0 || this.filteredWebAppSpecs.length > this.noCasualApps - 1) {
              this.roleSwitcher = true;
            }

            this.menuItemSpecs.push({
              resourceId:   this.webAppName,
              name:         'Home',
              link:         this.webAppName === 'web' ? this.webAppSuiteLink : currentWebAppSpec.webAppUrl,
              id:           'Home',
              label:        Soho.Locale.translate('Home'),
              resourceType: 'page'
            });


            this.markForRefresh();
            this.updateRequired = true;
          } else {
            this.lmApplicationMenuService.updateApplicationMenuSpec(applicationMenuSpec.webApps);
          }
        } else {
          if (this.useAppSwitcher()) {
            this.loadWebAppMenuSpec(this.webAppMenuNavigationUrl);
          } else {
            this.lmApplicationMenuService.updateApplicationMenuSpec(applicationMenuSpec.webApps);
          }
        }

        this.hideBusyIndicator();
        this.lmLoggerService.trace('@ApplicationMenuBaseDirective -> loadApplicationMenuSpec -> complete');
      },
      error => {
        // acces denied error is handled in app.component.ts
        if (error.status !== 403) {
          this._handleError(error);
        }
      }));
  }

  public updateButtons() {
    this.updateMyMenuButtons();
  }

  public saveAllLevelsResponse(response) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const expandedMenus = this.lmApplicationMenuService.getExpandedMenus();

    if (expandedMenus && expandedMenus.length > 0
      && response.menuSpecs && response.menuSpecs.length > 0
    ) {
      response.menuSpecs.map(function callback(menuItemSpec: LMMenuItemSpec) {
        if (expandedMenus.includes(menuItemSpec.menuIndex)) {
          menuItemSpec.expanded = true;
        }

        if (menuItemSpec.menuIndex === self.lmApplicationMenuService.getLastMenuItemClicked()) {
          menuItemSpec.selected = true;
        }

        if (menuItemSpec.menu && menuItemSpec.menu.length > 0) {
          menuItemSpec.menu.map(callback);
        }
      });
    }

  }

  public useRoleSwitcher() {
    return this.filteredWebAppSpecs.length === 0 || this.filteredWebAppSpecs.length > this.noCasualApps - 1;
  }

  private loadWebAppMenuSpec(url: string) {
    this.subscriptionArray.push(this.lmWebAppService.getWebAppMenuSpecWithUrl(this.webAppName, url)
      .subscribe(async applicationMenuSpec => {

        this.saveAllLevelsResponse(applicationMenuSpec);
        this.updateMenuItemSpecs(applicationMenuSpec.menuSpecs);
        this.lmApplicationMenuService.updateApplicationMenuSpec(applicationMenuSpec.menuSpecs, this.webAppMenuNavigationUrl);
        this.filteredWebAppSpecs = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName !== this.webAppName && webAppSpec.webAppTitle);
        this.roleSwitcher = this.useRoleSwitcher();
        this.markForRefresh();
        this.updateRequired = true;

        this.lmContextUtilService.setDrillbackDialogElement(this.drillbackPlaceholder, this.lmActionFormDialogService);
        const dialogId = 'ApplicationMenuResponse';

        if (applicationMenuSpec.buildBaseMenuMessage) {
          this.sohoMessageService
            .message()
            .message(Soho.Locale.translate(applicationMenuSpec.buildBaseMenuMessage))
            .title('')
            .buttons([
              {
                id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
                text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
                click: (e, modal) => {
                  modal.close(true);
                }
              },
            ])
            .open();
        }
      },
      error => {
        this._handleError(error);
      }));
  }

  private updateMyMenuButtons() {
    this.applicationMenuButtons = [];
    this.myOverflowMenuButtons = [];

    if (this.evaluateApplicationMenuOption('HideMenuPrintFiles')) {
      this.applicationMenuButtons.push({
        icon: 'print',
        label: Soho.Locale.translate('MyPrintFiles'),
        id: 'MyPrintFiles_button',
        url: this.printFilesUrl,
        automationId: 'lm-my-print-files-button'
      });
    }

    if (this.notificationEnabled && this.evaluateApplicationMenuOption('HideMenuNotifications')) {
      this.applicationMenuButtons.push({
        icon: 'notification',
        label: Soho.Locale.translate('MyNotifications'),
        id: 'MyNotifications_button',
        url: this.notificationsUrl,
        automationId: 'lm-my-notifications-button'
      });
    }

    if (this.inbasketEnabled && this.evaluateApplicationMenuOption('HideMenuInbasket')) {
      this.applicationMenuButtons.push({
        icon: 'download',
        label: Soho.Locale.translate('MyInbasket'),
        id: 'MyInbasket_button',
        url: this.inBasketUrl,
        automationId: 'lm-my-inbasket-button'
      });
    }

    if (this.evaluateApplicationMenuOption('HideMenuJobs')) {
      this.applicationMenuButtons.push({
        icon: 'cascade-objects',
        label: Soho.Locale.translate('MyJobs'),
        id: 'MyJobs_button',
        url: this.jobsUrl,
        automationId: 'lm-my-jobs-button'
      });
    }

    if (this.evaluateApplicationMenuOption('HideMenuReports')) {
      if (this.reportsUrl) {
        let reportsLabel = Soho.Locale.translate('MyReports');
        if (this.reportsUrl.includes('/report/catalog')) {
          reportsLabel = Soho.Locale.translate('ReportCatalog');
        }
        this.applicationMenuButtons.push({
          icon: 'report',
          label: reportsLabel,
          id: 'MyReports_button',
          url: this.reportsUrl,
          automationId: 'lm-my-reports-button'
        });
      }
    }

    if (this.evaluateApplicationMenuOption('HideMenuActions')) {
      this.applicationMenuButtons.push({
        icon: 'checkbox',
        label: Soho.Locale.translate('MyActions'),
        id: 'MyActions_button',
        url: this.actionsUrl,
        automationId: 'lm-my-actions-button'
      });
    }

    if (this.personalizationEnabled) {
      if (this.applicationMenuButtons.length === 6 && !this.enableSavedSearch) {
        this.applicationMenuButtons.push({
          icon: 'quick-edit',
          label: Soho.Locale.translate('MyPersonalizations'),
          id: 'MyPersonalization_button',
          url: this.personalizationsUrl,
          automationId: 'lm-my-personalizations-button'
        });
      } else if (this.applicationMenuButtons.length === 6 && this.enableSavedSearch) {
        this.showOverFlowMenuButton = true;
        this.myOverflowMenuButtons.push({
          icon: 'quick-edit',
          label: Soho.Locale.translate('MyPersonalizations'),
          id: 'MyPersonalization_button',
          url: this.personalizationsUrl,
          automationId: 'lm-my-personalizations-button'
        });
      } else {
        this.applicationMenuButtons.push({
          icon: 'quick-edit',
          label: Soho.Locale.translate('MyPersonalizations'),
          id: 'MyPersonalization_button',
          url: this.personalizationsUrl,
          automationId: 'lm-my-personalizations-button'
        });
      }
    }

    if (this.enableSavedSearch) {
      if (this.applicationMenuButtons.length === 6 && !this.personalizationEnabled) {
        this.applicationMenuButtons.push({
          icon: 'print-preview',
          label: Soho.Locale.translate('MySavedSearches'),
          id: 'MySavedSearches_button',
          url: this.savedSearchesUrl,
          automationId: 'lm-my-saved-searches-button'
        });
      } else if (this.myOverflowMenuButtons.length === 1 && this.personalizationEnabled) {
        this.showOverFlowMenuButton = true;
        this.myOverflowMenuButtons.push({
          icon: 'print-preview',
          label: Soho.Locale.translate('MySavedSearches'),
          id: 'MySavedSearches_button',
          url: this.savedSearchesUrl,
          automationId: 'lm-my-saved-searches-button'
        });
      } else {
        this.applicationMenuButtons.push({
          icon: 'print-preview',
          label: Soho.Locale.translate('MySavedSearches'),
          id: 'MySavedSearches_button',
          url: this.savedSearchesUrl,
          automationId: 'lm-my-saved-searches-button'
        });
      }

      this.menuItemSearch = this.applicationMenuButtons.concat(this.myOverflowMenuButtons);
    }

    // Add About Link
    if (!this.hasChangePasswordLink) {
      this.menuItemSearch.push({
        icon: 'print-preview',
        label: Soho.Locale.translate('About'),
        id: 'About_button',
        url: this.aboutLink,
        automationId: 'lm-about-button'
      });
    }

    if (this.appHelpLink && !this.hasChangePasswordLink) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('Help'),
        id: 'Help_button',
        url: this.appHelpLink,
        automationId: 'lm-help-button'
      });
    }

    if (this.proxyEnabled || this.proxyMode || this.proxyManagementLink) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('Proxy'),
        id: 'Proxy_button',
        url: '',
        automationId: 'lm-proxy-button'
      });
    }

    if (this.enableUserContextMenu) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('ActorContextMenuLabel'),
        id: 'ContextMenu_button',
        url: '',
        automationId: 'lm-contextMenu-button'
      });
    }

    if (this.createReportUrl) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('CreateReport'),
        id: 'CreateReport_button',
        url: '',
        automationId: 'lm-createReport-button'
      });
    }

    if (!this.hasChangePasswordLink) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('Settings'),
        id: 'Settings_button',
        url: '',
        automationId: 'lm-settings-button'
      });
    }
  }

  public closeActionMenu() {
    this.actionMenu.nativeElement.style.display = 'none';
    this.actionMenuIsOpen = false;
  }

  private useAppSwitcher(): boolean {
    return (this.appSwitcher === 'casual' || this.appSwitcher === 'popup' || this.appSwitcher === 'accordion' || this.appSwitcher === 'suite');
  }

  public markForRefresh() {
    this.changeDetectorRef.markForCheck();
  }

  public markForRefreshAndUpdate() {
    this.markForRefresh();
    this.updateRequired = true;
  }

  public _handleError(error: any, placeholder?: ViewContainerRef): void {
    this.lmErrorUtilService.handleUnexpectedError(error, placeholder);
  }

  private getUnreadNotificationCount() {
    let unreadCountUrl = this.lmUrlUtilService.getBannerSpecUrl();
    unreadCountUrl += (unreadCountUrl.indexOf('?') > -1 ? '&' : '?') + 'requestType=unreadCount';
    this.pause$.next(true);
    this.lmSpecService.getApplicationBannerSpec(unreadCountUrl).subscribe(
      (response: LMApplicationBannerSpec) => {
        this.pause$.next(false);
        this.unreadNotificationCount = (response.unreadCount) ? parseInt(response.unreadCount, 10) : 0;
        this.displayRedDot = this.evaluateApplicationMenuOption('HideMenuNotifications') ? this.unreadNotificationCount > 0 : false;
        this.markForRefresh();
      },
      error => {
        // In 3.5, the error is logged in the console for unread count and not prompted in dialog.
        // So timeout or when server down will not open up a dialog for a background poll request.
        // this._handleError(error);
        this.lmLoggerService.log([ this, error.status, error.message, 'Get unread notification count failed.' ]);
      });
  }

  public applicationMenuSearch() {
    this.showBusyIndicator();
    const menuSearchUrl = this.lmApplicationMenuSearchService.getMenuSearchUrl(encodeURIComponent(this.model.searchFieldValue));
    const observables: Observable<any>[] = [];


    this.subscriptionArray.push(this.lmSpecService.getRedirectUrl(menuSearchUrl).subscribe(response => {
      const dataMenus = response.dataModules;
      const reports = response.reports;
      const totalWebAppMenu = this.webAppSpecs.length + 1;

      const searchMenuSpecs = this.lmWebAppService.getAllCachedWebApps();
      if (totalWebAppMenu > searchMenuSpecs.length) {
        this.webAppSpecs.forEach((webApp) => {
          const menu = searchMenuSpecs.filter(webAppSpec => webAppSpec.webAppName === webApp.webAppName);
          if (webApp.navigationMenuUrl && menu.length === 0) {
            const url = this.lmUrlUtilService.appendToQueryString(webApp.navigationMenuUrl, 'allLevels=true');
            observables.push(this.lmWebAppService.getWebAppMenuSpec(webApp.webAppName).pipe(catchError(error => of(this.handleForkJoinError(error)))));
          }
        });
        if (observables.length > 1) {
          this.subscriptionArray.push(forkJoin(observables).subscribe(results => {
            this.searchMenu(dataMenus, reports);
          }));
        } else {
          this.searchMenu(dataMenus, reports);
        }
      } else {
        this.searchMenu(dataMenus, reports);
      }
    },
    error => {
      this.hideBusyIndicator();
      this._handleError(error);
    }));
  }

  private handleForkJoinError(error) {
    if (error.status === 504) {
      console.error(`Searching ${error.error.webApp} has timed out`);
    }
  }

  public searchMenu(dataMenus: LMApplicationMenuDataMenu[], reports: LMApplicationMenuReportMenu[]) {
    this.menuSearchResultsByWebApp = this.lmApplicationMenuSearchService.matchMultiMenus(this.lmWebAppService.getAllCachedWebApps(), this.model.searchFieldValue);
    this.dataSearchResult = this.lmApplicationMenuSearchService.matchData(dataMenus);
    this.reportSearchResult = this.lmApplicationMenuSearchService.matchReports(reports);
    this.systemSearchResults = this.lmApplicationMenuSearchService.matchMenuOptions(this.menuItemSearch, this.model.searchFieldValue);

    this.searchMode = true;

    const event: LMApplicationMenuSearchEvent = {
      searchString:              this.model.searchFieldValue,
      menuSearchResultsByWebApp: this.menuSearchResultsByWebApp,
      systemSearchResults:       this.systemSearchResults,
      dataSearchResults:         this.dataSearchResult,
      reportSearchResults:       this.reportSearchResult,
      menuItemSearch:            this.menuItemSearch,
      toggleMenu:                Object.keys(this.menuSearchResultsByWebApp).length > 0 ? 'Applications' : this.reportSearchResult.length > 0 ? 'Reports' : 'Data'
    };

    this.model.searchFieldValue = '';

    this.menuSearched.emit(event);
    this.hideBusyIndicator();
  }

  autoSearchMenu(searchValue: string) {
    this.searchFieldText$.next(searchValue);
  }

  onSystemMenuItemClick(systemSearchResult) {
    if (systemSearchResult.id === 'Proxy_button') {
      this.openProxyPage();
    } else if (systemSearchResult.id === 'Help_button') {
      this.openHelpLink();
    } else if (systemSearchResult.id === 'ContextMenu_button') {
      this.openSetUserContextDialog();
    } else if (systemSearchResult.id === 'CreateReport_button') {
      this.runCreateReport();
    } else if (systemSearchResult.id === 'Settings_button') {
      this.openUserSettingsDialog();
    } else if (systemSearchResult.id === 'AsOfDate_button') {
      this.openSetAsOfDateDialog();
    } else if (systemSearchResult.url) {
      this.openLink(systemSearchResult.url);
    }
  }

  public openLink(link: string) {
    if (link === this.notificationsUrl) {
      this.displayRedDot = false;
      // Convert timestamp from simplified ISO format (YYYY-MM-DDTHH:mm:ss.sssZ) to Landmark format (yyyyMMddHHmmssSS)
      const curTimeStamp = new Date().toISOString().slice(-24).replace(/\D/g, '').slice(0, 16);
      this.lmRoamingUIProfileService.setLastViewedNotification(curTimeStamp)
        .subscribe(
          (results: RoamingUIProfileResponse) => {
            if (results.status === RoamingUIProfileResult.COMPLETED) {
              this.lmLoggerService.log('RoamingUIProfile Updated');
            }
          });
    }
    const compiledTemplate = urltemplate.parse(link);
    link = compiledTemplate.expand({
      urlPdlOrDa: this.lmContextService.getUrlPdlOrDa(),
      webApp:     this.lmContextService.getCurrentWebAppSpec().webAppName
    });
    this.lmContextService.setClearNextPageState(true);
    this.lmGlobalUtilService.navigateByUrl(link);
  }

  // Save this code for menu search implementation
  fireMenuSearchEvent(event: Event) {
    if (!this.model.searchFieldValue) {
      // if value is blank then fire clearSearchEvent event
      this.fireClearSearchEvent(event);
    } else {
      // if searchfieldvalue length is 3 or more the auto search with perform this.applicationMenuSearch();
      if (this.model.searchFieldValue.length <= 2) {
        this.applicationMenuSearch();
      }
    }
  }

  fireClearSearchEvent(event) {
    this.searchMode = false;

    const toolbarSearchEvent: LMToolbarSearchEvent = {
      event,
      searchField: this.menuSearchField
    };
  }

  public openProxyPage() {
    const dialogId = 'Proxy';
    let title: string;

    if (this.proxyEnabled) {
      title = Soho.Locale.translate('SwitchToProxy');
    } else if (this.proxyMode) {
      title = Soho.Locale.translate('SwitchBackFromProxy');
    } else {
      title = Soho.Locale.translate('ProxyManagement');
    }

    let proxyMenuComponent: LMApplicationMenuProxyMenuComponent;
    this.dialog = this.sohoModalDialogService
      .modal(LMApplicationMenuProxyMenuComponent, this.placeholder, { fullsize: 'responsive' })
      .apply((proxyMenu: LMApplicationMenuProxyMenuComponent) => {
        proxyMenuComponent = proxyMenu;
        if (this.proxyMode) {
          proxyMenuComponent.proxyMode = this.proxyMode;
          proxyMenuComponent.proxyResetUrls = this.proxyResetUrls;
        }
        if (this.proxyEnabled) {
          proxyMenuComponent.proxyEnabled = this.proxyEnabled;
          proxyMenuComponent.proxyUserUrls = this.proxyUserUrls;
        }
        if (this.proxyManagementLink) {
          proxyMenuComponent.proxyManagementLink = this.proxyManagementLink;
        }
      })
      .buttons([
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CANCEL ]),
          text: Soho.Locale.translate(LMDialogButtonKey.CANCEL),
          click: (e, modal) => {
            modal.isCancelled = true;
            modal.close(true);
          }
        }
      ])
      .title(title)
      .open();
  }

  // todo: vwiny spec-url-refactor doesn't seem to be used. - Phillip
  public openChangePasswordWindow() {
    const subscription = this.lmSpecService.getFormSpecFromRedirectActionUrl(this.changePasswordLink)
      .subscribe((response: LMActionFormUrlResponse | LMSystemException) => {

        if ((response as LMSystemException).status
          && ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
            || (response as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
          // TODO: This function is currently not in use. The caller of this function will determine what to do with busy indicator or how to display the error message.
          // this.lmBusyIndicatorService.hideBusyIndicator();
          // this.lmErrorUtilService.handleError((response as LMSystemException).statusText, (response as LMSystemException).details);
          return;
        }

        const formUrlInfo = (response as LMActionFormUrlResponse).formUrlInfo;
        const formSpec = (response as LMActionFormUrlResponse).formSpec;
        const resourceId = (response as LMActionFormUrlResponse).resourceId;
        const actionName = (response as LMActionFormUrlResponse).action;
        const actionSpec: LMActionSpec = this.lmApplicationMenuService.getChangePasswordAction(formSpec.busClassSpec.actions, 'ChangePasswordUIMenu');
        const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
        const dataUrl = urlCompiledTemplate.expand({ resourceId, actionName });

        actionSpec.isChangePassword = true;

        this.lmActionFormDialogService.getActionFormDialogDataView(dataUrl).subscribe((responseDV: any) => {
          const formDataView: LMDataView = responseDV;

          if (formDataView.status !== AppConstants.STATUS_COMPLETED) {
            this.lmLoggerService.error(responseDV);
            this.lmErrorUtilService.handleError(responseDV.message, responseDV.details, responseDV.status, responseDV.statusText);
            return;
          }

          this.lmActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, actionSpec, formDataView)
            .subscribe((actionFormDialogResult: LMActionFormDialogResult) => {
              if (actionFormDialogResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                // Called by both menu v1 and v2. And most likely in v3 too under development.
                const actionResult: LMActionResult = actionFormDialogResult.transactionStateResult.getTransactionResult();

                if (!actionResult.actionSpec?.suppressCompletionMessage) {
                  this.lmGlobalUtilService.displayToastMessage(actionSpec.label, actionResult.message, AppConstants.TRA_ACTION_COMPLETED);
                }
              }
            });
        });
      });

    this.subscriptionArray.push(subscription);
    return false; // todo why return false?
  }

  public openLoginWindow() {
    const loginDialog = this.lmLoginService.promptLoginDialog(this.loginPlaceholder).subscribe((result: LoginResult) => {
      if (result.status === LoginDialogStatus.RESPONSE_OK) {
        this.lmLoggerService.log(result);
      }
    });

    this.subscriptionArray.push(loginDialog);
    return false; // todo why return false?
  }

  public webAppSwitcherButtonId: string;

  private onSwitchToProxyClicked(switchProxyUrl: string) {
    this.lmGlobalUtilService.navigate(switchProxyUrl, null, 'replace');
  }

  public runCreateReport(): void {
    this.lmCreateReportDialogService.openCreateReportDialog(
      'createReportFromBanner',
      this.reportPlaceholder,
      this.createReportUrl,
      this.actorGroupSelectUrl,
      this.roleSelectUrl,
      this.roleGroupSelectUrl,
      this.reportFieldSearchUrl
    ).subscribe((result: LMReportPersonalizationDialogResult) => {
      if (result.status === LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED) {
        if (result.viewReport) {
          this.lmGlobalUtilService.navigateByUrl(result.reportUrl);
        } else {
          this.lmGlobalUtilService.displayToastMessage('', result.message, AppConstants.TRA_ACTION_COMPLETED);
        }
      }
      return;
    });
  }

  showBusyIndicator() {
    this.busyIndicator.open();
  }

  hideBusyIndicator() {
    this.busyIndicator.close(false);
  }

  public getApplicationMenuPersonalization() {
    const applicationMenuPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    if (!isEmpty(applicationMenuPersonalization)) {

      if (applicationMenuPersonalization.lastOpenedMenu) {
        this.lmApplicationMenuService.lastOpenedMenuId = applicationMenuPersonalization.lastOpenedMenu;
      } else if (this.lmContextService.menuSearchOpenIndex() != null) {
        this.lmApplicationMenuService.saveLastMenuItemClicked(this.lmContextService.menuSearchOpenIndex());
        this.lmApplicationMenuService.addExpandedMenus(this.lmContextService.menuSearchOpenIndex());
      } else {
        this.lmApplicationMenuService.resetLastOpenedMenu();
      }
    }
  }

  public resetMenuPersonalization() {
    const applicationMenuPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();

    if (!isEmpty(applicationMenuPersonalization) && applicationMenuPersonalization.lastOpenedMenu) {
      applicationMenuPersonalization.lastOpenedMenu = '';
    }
    this.lmGlobalPersonalizationService.saveGlobalPersonalization(applicationMenuPersonalization);

    this.lmApplicationMenuService.resetLastOpenedMenu();
  }

  public loadWebAppMenu(button: any): void {
    this.showBusyIndicator();
    const url = button.getAttribute('navigationmenuurl');
    this.selectedWebAppName = button.getAttribute('id');

    // For webapp without a navigation menu
    if (!url) {
      this.resetMenuItemSpecs();
      const currWebAppSpec = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName === this.selectedWebAppName);

      this.menuItemSpecs.push(
        {
          resourceId:   currWebAppSpec.length === 0 && this.selectedWebAppName === 'web' ? this.selectedWebAppName : currWebAppSpec[ 0 ].webAppName,
          name:         'Home',
          link:         currWebAppSpec.length === 0  && this.selectedWebAppName === 'web' ? url : currWebAppSpec[ 0 ].webAppUrl,
          id:           'Home',
          label:        Soho.Locale.translate('Home'),
          resourceType: 'page'
        });

      this.markForRefresh();
      this.updateRequired = true;

      this.hideBusyIndicator();
    } else {
      this.subscriptionArray.push(this.lmWebAppService.getWebAppMenuSpec(this.selectedWebAppName).subscribe(
        applicationMenuSpec => {
          this.saveAllLevelsResponse(applicationMenuSpec);

          this.updateMenuItemSpecs(applicationMenuSpec.menuSpecs);

          this.lmApplicationMenuService.setApplicationMenuSpec(this.menuItemSpecs);

          this.lmApplicationMenuService.updateApplicationMenuSpec(applicationMenuSpec.menuSpecs, url);

          this.markForRefresh();
          this.updateRequired = true;

          this.hideBusyIndicator();
        },
        error => {
          this._handleError(error);
        }));
    }
  }

  public selectMenuSpec(webAppName: string) {
    const webAppMenu = this.lmWebAppService.getAllCachedWebApps().filter(webAppSpec => webAppSpec.webAppName === webAppName);
    if (webAppMenu.length === 1) {
      return webAppMenu[ 0 ].menuSpecs;
    }
    return [];
  }

  public webAppId(webAppName: string): string {
    return webAppName + (this.lmContextService.testVersion() >= AppConstants.TESTVERSION_V2 ? '_webapp' : '');
  }

  private getActorInitials(): string {
    const actorName = this.actorName;
    const parts = actorName.split(' ');
    const initials = [];

    parts.forEach((p) => {
      p.split('').forEach((s, index) => {
        if (index === 0) {
          initials.push(s);
        }
      });
    });

    return initials.join('');
  }

  /**
   * Data and reporting options are disabled by default.
   * And should display if included in the configured features list.
   * @param configuredFeature
   * @private
   */
  public showDataAndReportingOptions(configuredFeature: LMConfiguredFeatures): boolean {
    if (this.isGuestUser) {
      return false;
    }

    if (this.allowAnonymousAccess) {
      if (!this.configFeaturesEnabled) {
        return false;
      }
    }

    return this.lmContextService.getContext().configuredFeatures.includes(configuredFeature);
  }

  /**
   * Show if not in configured features list.
   * Application menu options are enabled by default.
   * If application menu option is in config features list then it was disabled and shouldn't be displayed
   * @param buttonName
   * @private
   */
  public evaluateApplicationMenuOption(buttonName: LMConfiguredFeatures): boolean {
    if (this.isGuestUser) {
      return false;
    }

    if (this.allowAnonymousAccess) {
      if (!this.configFeaturesEnabled || this.anonymousUser) {
        return false;
      }
    }

    return !this.lmContextService.getContext().configuredFeatures.includes(buttonName);
  }

  /**
   * Determines if proxy should be displayed in the template
   * If allowAnonymousAccess, config features should be enabled to display proxy
   * @private
   */
  private evaluateProxy(applicationMenuSpec: LMApplicationBannerSpec): boolean {
    if (this.isGuestUser) {
      return false;
    }

    if (this.allowAnonymousAccess) {
      if (!this.configFeaturesEnabled) {
        return false;
      }
    }

    return applicationMenuSpec.proxyEnabled || applicationMenuSpec.proxyMode || applicationMenuSpec.proxyManagementLink !== undefined;
  }

  /**
   * Determines if "as of date" should be displayed in the template
   * If allowAnonymousAccess, config features should be enabled to display "as of date"
   * @private
   */
  private evaluateAsOfDate(applicationMenuSpec: LMApplicationBannerSpec) {
    if (this.isGuestUser) {
      return false;
    }

    if (this.allowAnonymousAccess) {
      if (!this.configFeaturesEnabled) {
        return false;
      }
    }

    return applicationMenuSpec.allowSetAsOfDate;
  }

  /**
   * Determines if "Create Report" should be displayed in the template
   * If allowAnonymousAccess, config features should be enabled to display "Create Report"
   * @private
   */
  private evaluateCreateReportUrl(applicationMenuSpec: LMApplicationBannerSpec): string | undefined {
    if (this.isGuestUser) {
      return undefined;
    }

    if (this.allowAnonymousAccess) {
      if (!this.configFeaturesEnabled) {
        return undefined;
      }
    }

    return applicationMenuSpec.createReportUrl;
  }

  /**
   * Determines if "personalization" should be displayed in the template
   * If allowAnonymousAccess, config features should be enabled to display "personalization"
   * @private
   */
  private evaluatePersonalization(applicationMenuSpec: LMApplicationBannerSpec): boolean {
    if (this.isGuestUser) {
      return undefined;
    }

    if (this.allowAnonymousAccess) {
      if (!this.configFeaturesEnabled) {
        return undefined;
      }
    }

    return applicationMenuSpec.personalizationEnabled;
  }

  /**
   * Determines if "search" should be displayed in the template
   * If allowAnonymousAccess, config features should be enabled to display "search"
   * @private
   */
  private evaluateShowSearch() {
    if ((this.isGuestUser || this.anonymousUser) || (this.allowAnonymousAccess && !this.configFeaturesEnabled)) {
      return undefined;
    }

    return !this.lmContextService.getContext().configuredFeatures.includes('HideMenuSearch');
  }

  /**
   * Used for data-automation-id, this function will convert underscores _ and
   * _prd_ to a dash -
   * @param menuItem
   */
  public dataAutomationId(menuItem: LMBannerSearchResult|LMMenuItemSpec) {
    return `lm-${menuItem.automationId}-menuitem`;
  }

  public onMenuItemClicked(event: MouseEvent, menuItem: any) {
    // Reset href to hash for regular click events.
    (event.target as HTMLElement).setAttribute('href', '#');
    this.lmApplicationMenuService.saveLastMenuItemClicked(menuItem.menuIndex);

    if ((event.ctrlKey || event.metaKey) && event.shiftKey) {
      this.displayComponentInfo(menuItem, event);
      return false;
    }

    if (this.throttleClickEvent(menuItem)) {
      return;
    }

    this.setLastOpenedMenu(menuItem);

    if (menuItem.menu) {
      return;
    }
    this._menuItemClicked$.next(menuItem);
  }

  public throttleClickEvent(menuItem: any): boolean {
    if (this.throttleId && this.throttleId === menuItem.id) {
      return true;
    }

    this.throttleId = menuItem.id;

    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.throttleId = null;
      }, 500);
    });
    return false;
  }

  private setLastOpenedMenu(menuItem: any) {
    this.lmApplicationMenuService.lastOpenedMenuId = menuItem.appMenuId; // this.getMenuItemId(menuItem);

    const applicationMenuPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    if (!isEmpty(applicationMenuPersonalization)) {
      this.settings = applicationMenuPersonalization;
    }
    this.settings.lastOpenedMenu = this.lmApplicationMenuService.lastOpenedMenuId;

    this.savePersonalization();
  }

  public displayComponentInfo(menuItem: LMComponentInfo, event: MouseEvent) {
    event.stopPropagation();
    // event.preventDefault();
    const hasSubMenu = menuItem.menu && menuItem.menu !== undefined && menuItem.menu.length > 0;
    const configInfo = hasSubMenu && menuItem.menu[menuItem.menuIndex] ? menuItem.menu[menuItem.menuIndex].configInfo : {};
    const compConfigInfo: ConfigInfo = {};
    compConfigInfo['personalization'] = hasSubMenu && configInfo ? configInfo.personalization : false;
    compConfigInfo['configuration'] = hasSubMenu && configInfo ? configInfo.configuration : false;
    compConfigInfo['configStamp'] = configInfo && configInfo.configStamp ? configInfo.configStamp : 0;
    compConfigInfo['classConfigStamp'] = configInfo && configInfo.classConfigStamp ? configInfo.classConfigStamp : 0;

    const compInfo: LMComponentInfo = {
      componentType: 'MENU',
      type: hasSubMenu ? 'menuItem' : 'menu',
      name: menuItem.name,
      developer: this.lmContextService.isDeveloper(),
      id: menuItem.id,
      label: menuItem.label,
      link: menuItem.link,
      menuIndex: menuItem.menuIndex,
      parent: menuItem.parent,
      parentLabel: menuItem.parentLabel,
      resourceId: menuItem.resourceId,
      resourceType: menuItem.resourceType,
      resourceInfo: menuItem.resourceInfo ? menuItem.resourceInfo : undefined,
      target: menuItem.target,
      lpl: menuItem.lpl,
      configInfo: compConfigInfo,
      hasConfigAccess: hasSubMenu ? this.lmContextService.hasConfigAccess() : false,
    };
    this.lmComponentInfoService.displayComponentInfo(event as LMCtrlShiftClickEvent, this.menuFormDialogPlaceholder, compInfo);
  }

  public savePersonalization(): void {
    this.lmGlobalPersonalizationService.saveGlobalPersonalization(this.settings);
  }

  public doMenuItemClicked(menuItem: any) {
    const routeComponent: LMRouteComponentService = this.routeComponent;

    // Pause menu clicks
    this._pause$.next(true);
    // Resume menu clicks after 20 seconds. This is to prevent ApplicationMenu from locking up
    // if a back end call failed for some reason and we did not catch it.
    // Challenging to get this working, every click creates a timer and it gets out of control.
    // this.menuTimerSubscription = timer(20000).subscribe(() => this.pause$.next(false));

    this.lmBusyIndicatorService.showBusyIndicator(); // Dialog open will hide the busy indicator
    this.lmSpecService.getApplicationMenuItemSpec(menuItem.link).subscribe(
      response => {
        if (response.resourceType === 'action') {
          if (!this.isActionInvalid()) {
            this.lmApplicationMenuSubMenuService.runAction(response.dialogUrl || response.redirectUrl, response.dataView, this.placeholder, this._pause$);
          }
        } else if (response.dialogUrl) {
          const personalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
          if (this.lmContextService.is3_5Content(personalization.appDisplay)) {
            const comp: LMHtmlUrlDocComponent = routeComponent.getHtmlUrlDocComponent();
            comp.runActionFormIn3_5(response.dialogUrl);
            this._pause$.next(false);
          } else {
            if (!this.isActionInvalid()) {
              this.lmApplicationMenuSubMenuService.requestActionFromPageMenu(response.dialogUrl, response.resourceId, this.placeholder, this._pause$);
            }
          }
        } else if (response.redirectUrl) {
          this.lmContextService.setClearNextPageState(true);
          const url = response.redirectUrl;
          const noDefaultPortUrl = this.lmUrlUtilService.stripDefaultPort(url);
          let host = this.lmContextUtilService.getLocation(noDefaultPortUrl).host;

          // In IE, the host value includes the port number, we need to strip it so it will match the window.location.host
          if (this.lmBrowserUtilService.isIE) {
            host = this.lmUrlUtilService.stripDefaultPortFromHost(host);
          }

          const log = {
            codeLoc: 'lm-application-menu.component.td - onMenuItemClicked',
            url,
            noDefaultPortUrl,
            host,
            'window.location.host': window.location.host,
            'url.length': url.length,
            doHostsMatch: (host.toLowerCase() === window.location.host.toLowerCase()),
          };
          this.lmLoggerService.log(log);

          if (response.external) {
            this.lmBusyIndicatorService.hideBusyIndicator();
            this.lmUrlUtilService.openExternalUrl(response.redirectUrl);
          } else if (response.embedded) {
            if ((url.length > 0 && host !== window.location.host) || (response.redirectUrl.indexOf('.html') >= 0)) {
              const isHtmlFragment = response.redirectUrl.indexOf('standalone=true') < 0;
              const webapp = this.lmContextService.getContext().webApp;
              const dataArea = this.lmContextService.getContext().urlPdlOrDa;
              let autoLoadUrl = dataArea + '/' + webapp + '/html/url?autoLoadUrl=' + encodeURIComponent(response.redirectUrl);
              autoLoadUrl = this.lmUrlUtilService.updateContextSessionKeyParams(autoLoadUrl);
              this.lmGlobalUtilService.navigateByUrl(autoLoadUrl);
            } else {
              this.lmGlobalUtilService.navigateByUrl(noDefaultPortUrl);
            }
          } else {
            if ((url.length > 0 && host !== window.location.host) || (response.redirectUrl.indexOf('.html') >= 0)) {
              window.location.href = response.redirectUrl;
            } else {
              this.lmGlobalUtilService.navigateByUrl(noDefaultPortUrl);
            }
          }
          this._pause$.next(false);
        } else {
          this._handleError(response, this.menuFormDialogPlaceholder);
          this._pause$.next(false);
        }
      },
      error => {
        this._pause$.next(false);
        this._handleError(error, this.menuFormDialogPlaceholder);
      });
  }

  private isActionInvalid(): boolean {
    if (this.lmContextService.isDataModificationNotAllowed()) {
      this.lmGlobalUtilService.displayActionNotAllowed();
      this._pause$.next(false);
      this.lmBusyIndicatorService.hideBusyIndicator();
      return true;
    }
    return false;
  }

  public subscribeToMenuItemClick() {
    const pausable$ = this._pause$
      .pipe(
        switchMap(paused => paused ? EMPTY : this._menuItemClicked$),
        takeUntil(this._destroy$)
      );

    // this.pausableSubscription = pausable$.subscribe( (menuItem) => this.doMenuItemClicked(menuItem) );
    pausable$.subscribe( (menuItem) => {
      // this.menuTimerSubscription.unsubscribe();
      this.doMenuItemClicked(menuItem);
    });

    this._pause$.next(false);
  }
}
